@if (areAllTranslationsLoaded()) {
  <div class="row">
    <div class="col-12">
      @if (logItem().propertyGroup && logItem().propertyGroup !== 'null' && logItem().category === AuditCategoryDTO.MEASURES) {
        <span class="fw-bold">
        {{ 'measure.name.' + logItem().propertyGroup | cfpTranslate }}
      </span>
      }

      @if (logItem().propertyGroup && logItem().propertyGroup !== 'null' && logItem().category === AuditCategoryDTO.LABELS) {
        <span class="fw-bold">
        {{ 'labelGroup.' + logItem().propertyGroup | cfpTranslate }}
      </span>
      }

      @if (logItem().propertyGroup && logItem().propertyGroup !== 'null' && logItem().category === AuditCategoryDTO.ROADMAPLABELS) {
        <span class="fw-bold">
        {{ 'labelGroup.' + extractLabelPart(logItem().propertyGroup) | cfpTranslate }}
          {{ extractYearPart(logItem().propertyGroup) }}
      </span>
      }

      @if (logItem().propertyGroup && logItem().propertyGroup !== 'null' && (logItem().category === AuditCategoryDTO.WEIICONSUMPTION || logItem().category === AuditCategoryDTO.CRREMCONSUMPTION)) {
        <span class="fw-bold">
        {{ logItem().propertyGroup | cfpTranslate }}
      </span>
      }

      <span
        class="me-1"
        [class.fw-bold]="
        logItem().property &&
        !(
          logItem().propertyGroup &&
          logItem().propertyGroup !== 'null' &&
          logItem().category !== AuditCategoryDTO.ENERGYCONSUMPTION
        )
      "
        [innerHtml]="
        logItem().property
          | cfpTranslate
            : {
                unitType: ('measureUnitType.' + logItem().unitType + '.' + unitsArea | cfpTranslate)
              }
      "
      >
    </span>
    </div>
    <span class="text-muted col-12 col-sm mt-2">
    <span>{{ 'auditTrail.property.suffix' | cfpTranslate }}</span>
  </span>
    <span class="col-12 col-sm d-flex justify-content-start justify-content-sm-end mt-2">
    @if (showPriceField()) {
      <span
        class="fw-bold"
        [innerHTML]="
          (logItem().oldValue === 'null' ? '-' : logItem().oldValue || '-')
            | currency: logItem().currencyCode : 'symbol-narrow'
        "
      >
      </span>
    } @else {
      <span
        class="fw-bold"
        [innerHTML]="
          (logItem().oldValue === 'null' ? '-' : logItem().oldValue || '-')
            | translateConstructionPeriod
            | cfpTranslate
            | auditTrailUnit: logItem() : building() | async
        "
      >
      </span>
    }
      <span class="ms-1">
      <cfp-icon [iconStyle]="'dark'" [icon]="'arrow-right'" />
    </span>

      @if (showPriceField()) {
        <span
          class="fw-bold price-field"
          [innerHTML]="
          (logItem().oldValue === 'null' ? '-' : logItem().oldValue || '-')
            | currency: logItem().currencyCode : 'symbol-narrow'
        "
        >
      </span>
      } @else {
        <span
          class="fw-bold ms-1 normal-field"
          [innerHTML]="
          (logItem().newValue === 'null' ? '-' : logItem().newValue || '-')
            | translateConstructionPeriod
            | cfpTranslate
            | auditTrailUnit: logItem() : building() | async
        "
        >
      </span>
      }
      @if (logItem().propertyGroup &&
      logItem().propertyGroup !== 'null' &&
      logItem().category === AuditCategoryDTO.ENERGYCONSUMPTION) {
        <span class="col-auto ps-0 fw-bold ms-1">
        {{ 'auditTrail.attribute.prefix.' + AuditCategoryDTO.ENERGYCONSUMPTION | cfpTranslate }}
          {{ logItem().propertyGroup }}
      </span>
      }
  </span>
  </div>
  @if (buildingChangeLogItem()) {
    <span class="row justify-content-between">
    <span class="col-12 col-sm text-muted mt-2 mt-sm-0">
      {{ 'auditTrail.username.label' | cfpTranslate }}
    </span>
    <span class="col-12 col-sm text-start text-sm-end">
      {{ buildingChangeLogItem().userName }}
    </span>
  </span>
    <span class="row justify-content-between">
    <span class="col-12 col-sm text-muted mt-2 mt-sm-0">
      {{ 'auditTrail.creationDate.label' | cfpTranslate }}
    </span>
    <span class="col-12 col-sm text-start text-sm-end">
      {{ buildingChangeLogItem().creationDateTime | date: 'MMMM d, y, HH:mm' }}
    </span>
  </span>
    @if (buildingChangeLogItem().systemChanges?.length > 0) {
      <div class="col-12 mt-2">
        <cfp-alert [icon]="'info-circle'" [iconType]="'solid'" [alertStyle]="'light'">
          <p>{{ 'auditTrail.systemChanges.text' | cfpTranslate }}</p>
          <cfp-link (clicked)="showSystemChanges(buildingChangeLogItem().systemChanges)">
            {{ 'auditTrail.systemChanges.show' | cfpTranslate }}
            <cfp-icon [icon]="'arrow-right'" />
          </cfp-link>
        </cfp-alert>
      </div>
    }
  }
}
